import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, createSelector, on } from '@ngrx/store';
import moment from 'moment';
import {
    DeleteTransactionFailure,
    DeleteTransactionSuccess,
    LoadTransactionsFailure,
    LoadTransactionsSuccess
} from '../actions/employee-transaction.actions';
import { buildEmployeeTransactionEntities } from '../entity-builder-utils';
import { EmployeeTransactionEntity } from '../entity-models';
import { AppState } from '../store';

export interface EmployeeTransactionState extends EntityState<EmployeeTransactionEntity> {
    error: any;
}

function selectTransactionId(a: EmployeeTransactionEntity): string {
    return a.employeeTransactionId;
}

function sortTransactions(a: EmployeeTransactionEntity, b: EmployeeTransactionEntity): number {
    return moment(b.creationDateTime).toDate().getTime() - moment(a.creationDateTime).toDate().getTime();
}

export const employeeTransactionAdapter: EntityAdapter<EmployeeTransactionEntity> = createEntityAdapter<EmployeeTransactionEntity>({
    selectId: selectTransactionId,
    sortComparer: sortTransactions
});

export const initialState: EmployeeTransactionState = employeeTransactionAdapter.getInitialState({
    error: undefined
});

export const employeeTransactionReducer = createReducer(
    initialState,

    on(LoadTransactionsSuccess, (state, { transactions }) =>
        employeeTransactionAdapter.upsertMany(buildEmployeeTransactionEntities(...(transactions || [])), state)
    ),
    on(LoadTransactionsFailure, (state, { error }) => ({ ...state, error })),

    on(DeleteTransactionSuccess, (state, { transactionId }) => employeeTransactionAdapter.removeOne(transactionId, state)),
    on(DeleteTransactionFailure, (state, { error }) => ({ ...state, error }))
);

const { selectAll } = employeeTransactionAdapter.getSelectors();

export const employeeTransactionState = (state: AppState) => state.employeeTransactionState;
export const allEmployeeTransactions = createSelector(employeeTransactionState, selectAll);
export const employeeTransactionsByCase = (caseId: string) =>
    createSelector(allEmployeeTransactions, (transactions) => transactions.filter((transaction) => transaction.employeeCaseId === caseId));
